import { ProductType } from '../../../constants';
import type { CartResponseResponse } from '../../../model/cart/cart';

/** WordPress cart types are lowercase; catalog types use the shared enum casing. */
export function normalizeCartResponse<T extends CartResponseResponse>(response: T): T {
  return {
    ...response,
    cart: {
      ...response.cart,
      item: response.cart.item.map((item) => {
        switch (item.type?.toLowerCase()) {
          case 'simple':
            return { ...item, type: ProductType.Simple };
          case 'variable':
            return { ...item, type: ProductType.Variable };
          case 'variation':
            return { ...item, type: ProductType.Variation };
          default:
            return item;
        }
      }),
    },
  };
}
